import request from '@/utils/request'

export function mainten_store_list(data = {}) {
  return request({
    url: '/api/product_contact/mainten_store_list',
    method: 'post',
    data
  }).then(res => [res, null]).catch(err => [null, err])
}
export function mainten_product_list(data = {}) {
  return request({
    url: '/api/product_contact/mainten_product_list',
    method: 'post',
    data
  }).then(res => [res, null]).catch(err => [null, err])
}
export function edit_mainten_product_status(data = {}) {
  return request({
    url: '/api/product_contact/edit_mainten_product_status',
    method: 'post',
    data
  }).then(res => [res, null]).catch(err => [null, err])
}